import React, { Suspense } from 'react'
import { Routes as Switch, Route } from 'react-router-dom'
import {PublicRoutes} from "./PublicRoutes";
import { PrivateRoutes } from './PrivateRoutes'

import { Dashboard, DashboardGeneral } from "../Modules/Core/Dashboard";
import { Settings } from "../Modules/Core/Settings";
import { Users, View as UserView } from "../Modules/Core/Users";
import { Permissions } from "../Modules/Core/Permission";
import { Roles } from "../Modules/Core/Roles";
import { Loader } from "../Components";
import {Department, View as DepartmentView} from "../Modules/Roster/Department";
import {Calendar, View as ViewRoster, Generate as GenerateRoster} from "../Modules/Roster/Roster";
import {RosterArchive} from "../Modules/Roster/Archive";
import {View as ThemeView} from "../Modules/Core/Themes";
import {RosterJobs} from "../Modules/Core/RosterJobs";

// Lazy load auth components for code splitting
const Login = React.lazy(() => import("../Modules/Common/Auth/Components/Login").then(module => ({ default: module.Login })));
const Register = React.lazy(() => import("../Modules/Common/Auth/Components/Register").then(module => ({ default: module.Register })));
const SetPassword = React.lazy(() => import("../Modules/Common/Auth/Components/SetPassword").then(module => ({ default: module.SetPassword })));
const ForgotPassword = React.lazy(() => import("../Modules/Common/Auth/Components/ForgotPassword").then(module => ({ default: module.ForgotPassword })));
const VerifyEmail = React.lazy(() => import("../Modules/Common/Auth/Components/VerifyEmail").then(module => ({ default: module.VerifyEmail })));
const VerifyOtp = React.lazy(() => import("../Modules/Common/Auth/Components/VerifyOtp").then(module => ({ default: module.VerifyOtp })));
const Logout = React.lazy(() => import("../Modules/Common/Auth/Components/Logout").then(module => ({ default: module.Logout })));
const Error403 = React.lazy(() => import("../Modules/Common/Auth/Components/Error403").then(module => ({ default: module.Error403 })));
const Error404 = React.lazy(() => import("../Modules/Common/Auth/Components/Error404").then(module => ({ default: module.Error404 })));

export const OfficeRoutes = () => {

    return (
        <Switch>
            <Route element={<PublicRoutes layout={'ERROR'} />} >
                <Route exact path='/403' element={
                    <Suspense fallback={<Loader type="circular" />}>
                        <Error403 />
                    </Suspense>
                } />
                <Route exact path='/404' element={
                    <Suspense fallback={<Loader type="circular" />}>
                        <Error404 />
                    </Suspense>
                } />
            </Route>

            <Route element={<PublicRoutes layout={'AUTH'} />} >
                <Route exact path='/register' element={
                    <Suspense fallback={<Loader type="circular" />}>
                        <Register />
                    </Suspense>
                } />
                <Route exact path='/register/verify' element={
                    <Suspense fallback={<Loader type="circular" />}>
                        <VerifyOtp redirectTo={"/register/setup-password"} />
                    </Suspense>
                } />
                <Route exact path='/register/setup-password' element={
                    <Suspense fallback={<Loader type="circular" />}>
                        <SetPassword />
                    </Suspense>
                } />
            </Route>

            <Route element={<PublicRoutes layout={'AUTH'} />} >
                <Route exact path='/login' element={
                    <Suspense fallback={<Loader type="circular" />}>
                        <Login />
                    </Suspense>
                } />
                <Route exact path='/logout' element={
                    <Suspense fallback={<Loader type="circular" />}>
                        <Logout />
                    </Suspense>
                } />
                <Route exact path='/auth/verify/:email' element={
                    <Suspense fallback={<Loader type="circular" />}>
                        <VerifyEmail />
                    </Suspense>
                } />
                <Route exact path='/auth/forgot-password' element={
                    <Suspense fallback={<Loader type="circular" />}>
                        <ForgotPassword />
                    </Suspense>
                } />
                <Route exact path='/auth/forgot-password/verify' element={
                    <Suspense fallback={<Loader type="circular" />}>
                        <VerifyOtp redirectTo={"/setup-password"} />
                    </Suspense>
                } />
                <Route exact path='/setup-password' element={
                    <Suspense fallback={<Loader type="circular" />}>
                        <SetPassword />
                    </Suspense>
                } />
                <Route exact path='/auth/reset-password' element={
                    <Suspense fallback={<Loader type="circular" />}>
                        <SetPassword />
                    </Suspense>
                } />
            </Route>

            <Route element={<PrivateRoutes layout={'OFFICE'} allowedRoles={['ADMIN']}/>} >
                <Route exact path='/settings' element={<Settings />}/>
                <Route exact path='/themes' element={<ThemeView />}/>
                <Route exact path='/permissions' element={<Permissions />}/>
                <Route exact path='/roles' element={<Roles />}/>
                <Route exact path='/users/:id' element={<UserView />}/>
                <Route exact path='/users' element={<Users />}/>
                <Route exact path='/roster/jobs' element={<RosterJobs />}/>
            </Route>

            <Route element={<PrivateRoutes fullWidth={true} layout={'OFFICE'} allowedRoles={['ADMIN','MANAGER']} />} >
                <Route exact path='/' element={<Dashboard />}/>
                <Route exact path='/dashboard' element={<Dashboard />}/>
                <Route exact path='/dashboard/general' element={<DashboardGeneral />}/>
                <Route exact path='/roster/manage' element={<Calendar />} />
            </Route>

            <Route element={<PrivateRoutes fullWidth={false} layout={'OFFICE'} allowedRoles={['ADMIN','MANAGER']} />} >
                <Route exact path='/departments' element={<Department />} />
            </Route>

            <Route element={<PrivateRoutes fullWidth={false} layout={'OFFICE'} allowedRoles={['ADMIN','MANAGER']} />} >
                <Route exact path='/departments/:id' element={<DepartmentView />} />

                <Route exact path='/roster' element={<ViewRoster />} />
                <Route exact path='/roster/generate' element={<GenerateRoster />} />
                <Route exact path='/roster/archive' element={<RosterArchive />} />
            </Route>

            <Route element={<PrivateRoutes fullWidth={false} layout={'OFFICE'} allowedRoles={['STAFF']} />} >
                <Route exact path='/roster' element={<ViewRoster />} />

                <Route path="*" element={
                    <Suspense fallback={<Loader type="circular" />}>
                        <Error404 />
                    </Suspense>
                } />
            </Route>
        </Switch>
    )
}